import React, { memo, useCallback, useContext, useRef } from 'react'
import UploadIcon from 'assets/svgr-icons/Upload.svg'
import MyFilesIcon from 'assets/svgr-icons/My_Files.svg'
import ActionsFlyout from 'common-components/ActionsFlyout'
import { translate } from 'utils/translations'
import { ScrollableElementContext } from 'containers/SubSidebar/AiImageContent/contextApi'
import { T } from 'consts/translationKeys'
import MediaUploadButton from 'components/MediaUploadButton'
import { IImageAction, IProps } from './types'

const AiReferenceImagesFlyOut: React.FC<IProps> = ({
  onAddMediaImage,
  onUploadImage,
  isOpen,
  closeDropdown,
  addImageWrapperElement,
  availableImagesCount
}) => {
  const { scrollableElementRef } = useContext(ScrollableElementContext)
  const uploadTriggerRef = useRef<{ triggerUpload: () => void } | null>(null)

  const openMediaLib = () => {
    window.openMediaLib({
      onClose: window.closeMediaLib,
      mediaLibUnmountCb: window.closeMediaLib,
      onChoose: onAddMediaImage,
      maxFileImportCount: availableImagesCount,
      isVisible: true,
      stockAllowed: true,
      fileType: 'image',
      initialFolderName: 'My_Images'
    })
  }

  const handleUploadClick = useCallback(() => {
    uploadTriggerRef.current?.triggerUpload()
    closeDropdown()
  }, [closeDropdown])

  const imageAddActions: IImageAction[] = [
    {
      key: 'upload',
      title: translate(T.UPLOAD_LABEL_SIDEBAR),
      icon: <UploadIcon />,
      onClick: handleUploadClick
    },
    {
      key: 'my_files',
      title: translate(T.MY_FILES_LABEL),
      icon: <MyFilesIcon />,
      onClick: openMediaLib
    }
  ]

  return (
    <>
      <MediaUploadButton
        acceptType="image"
        handleFilesUpload={onUploadImage}
        refTrigger={uploadTriggerRef}
      />
      <ActionsFlyout
        actions={imageAddActions}
        isOpen={isOpen}
        anchorEl={addImageWrapperElement}
        onClose={closeDropdown}
        flyoutOptions={{
          position: 'right',
          alignmentY: 'top',
          extraOffset: 4
        }}
        isMobileWithDrawer
        scrollableElementRef={scrollableElementRef}
      />
    </>
  )
}

export default memo(AiReferenceImagesFlyOut)
